import { FormattedMessage as FM } from "react-intl";

import ListField from "./ListField";
import SectionToggle from "./SectionToggle";
import SheetCard from "./SheetCard";
import { ENGAGE_LINK_FIELD } from "../constants";

function EngageLinkCard({ form, onChange }) {
  return (
    <SheetCard title="melhous.dash.block.link">
      <div className="space-y-3">
        <p className="text-xs text-neutral-500">
          <FM id="melhous.dash.block.link_hint" />
        </p>
        <ListField
          field={ENGAGE_LINK_FIELD}
          value={form.link_melhous}
          onChange={onChange}
        />
        <SectionToggle
          name="require_table_qr"
          checked={form.require_table_qr}
          onChange={onChange}
          onText="melhous.dash.block.qr_on"
          offText="melhous.dash.block.qr_off"
        />
      </div>
    </SheetCard>
  );
}

export default EngageLinkCard;
